import { Button } from "../ui/button";
import { links } from "../../lib/links";
import { cn } from "../../lib/utils";

type Props = { className?: string };

export default function Footer({ className }: Props) {
  return (
    <footer className={cn("bg-gray-800 text-white py-12", className)}>
      <div className="container mx-auto px-4">
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-wrap justify-between items-center space-y-8">
          <div className="space-y-1">
            <p className="text-sm ">
              ©{new Date().getFullYear()} SportsEngine, Inc. The Home of Youth
              Sports. All Rights Reserved.
            </p>

            <div className="flex flex-col md:flex-row md:gap-2 text-gray-400">
              <a
                href={links.cookies.href}
                className="text-sm text-gray-400 hover:text-white mt-4 md:mt-0 underline underline-offset-3"
              >
                {links.cookies.label}
              </a>
              <span className="hidden md:inline">/</span>
              <a
                href={links.privacy.href}
                className="text-sm text-gray-400 hover:text-white mt-4 md:mt-0 underline underline-offset-3"
              >
                {links.privacy.label}
              </a>
              <span className="hidden md:inline">/</span>
              <a
                href={links.caNotice.href}
                className="text-sm text-gray-400 hover:text-white mt-4 md:mt-0 underline underline-offset-3"
              >
                {links.caNotice.label}
              </a>
              <span className="hidden md:inline">/</span>
              <a
                href={links.terms.href}
                className="text-sm text-gray-400 hover:text-white mt-4 md:mt-0 underline underline-offset-3"
              >
                {links.terms.label}
              </a>
              <span className="hidden md:inline">/</span>
              <a
                href={links.helpCenter.href}
                className="text-sm text-gray-400 hover:text-white mt-4 md:mt-0 underline underline-offset-3"
              >
                {links.helpCenter.label}
              </a>
            </div>
          </div>

          <div className="flex gap-4 items-center">
            <Button
              asChild
              variant="outline"
              className="border-white text-white bg-transparent rounded-full px-8"
            >
              <a href={links.contact.href}>{links.contact.label}</a>
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
}
